import { Table } from 'antd'
import styles from './AppTable.module.scss'

const AppTable = (props) => {
  const { loading, rowClassName, columns, dataSource } = props
  return (
    <>
      <Table
        loading={loading}
        rowClassName={rowClassName}
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        rowKey={(dataSource) => dataSource.id}
        className={styles.appTable}
      />
    </>
  )
}

export default AppTable
